import { Button, Grid, Modal } from '@design-systems/canvas-ui'
import { LOGOUT_WARNING_MESSAGE } from 'config/BusinessPartnerConsts'

type Props = {
  isOpen: boolean
  isLoggingOut: boolean
  onConfirm: () => void
  onCancel: () => void
}

export const PartnerTypeLogoutModal = ({
  isOpen,
  isLoggingOut,
  onConfirm,
  onCancel,
}: Props) => {
  return (
    <Modal
      headingText="Log out to update partner type?"
      isOpen={isOpen}
      onClose={onCancel}
      size="sm"
      footer={
        <Grid.Container justify="end">
          <Grid.Item>
            <Button
              variant="secondary"
              onClick={onCancel}
              isDisabled={isLoggingOut}
            >
              Cancel
            </Button>
          </Grid.Item>
          <Grid.Item>
            <Button
              variant="primary"
              onClick={onConfirm}
              isDisabled={isLoggingOut}
            >
              Save and log out
            </Button>
          </Grid.Item>
        </Grid.Container>
      }
    >
      <p>{LOGOUT_WARNING_MESSAGE}</p>
    </Modal>
  )
}

export default PartnerTypeLogoutModal
